import { render, staticRenderFns } from "./OtherOverheadsList.vue?vue&type=template&id=34862d94"
import script from "./OtherOverheadsList.vue?vue&type=script&lang=js"
export * from "./OtherOverheadsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports